import styled from 'styled-components';
import * as colors from '../../../common/colorConstants';
import { TicketTextRegular } from 'components/common/fontElements';

export const Container = styled.div`
  text-align: left;
  word-wrap: break-word;
  overflow-wrap: break-word;
  padding: 0px 25px 150px;
  height: 100%;
  overflow: scroll;
`;

export const HeadingSection = styled.section`
  padding: 24px 0px 0px 0px;
  overflow: auto;
`;

export const MacroBubble = styled.img`
  float: left;
`;

export const MacroHeading = styled.h3`
  float: left;
  margin: 0px;
  padding: 4px 10px;
  color: ${colors.purple1};
  font-family: 'Roboto', sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 18px;
`;

export const MacroContentSection = styled(TicketTextRegular)`
  white-space: normal;
  position: relative;
  color: ${colors.black4};
  font-family: 'Lato-Light', sans-serif;
  font-weight: 300;
  line-height: normal;

  padding: 35px 35px 50px;
  margin: 15px 0px;
  border: 1px solid ${colors.lightGray15};
  border-radius: 4px;

  img {
    max-width: 100%;
  }
`;

export const ActionButtons = styled.div`
  align-items: flex-start;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
  display: flex;
  flex-direction: row;
  padding: 0px 10px;
`;

export const BlockingAlert = styled.p`
  display: inline-block;
  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 11px;
  line-height: 16px;
  color: ${colors.black4};
  padding: 0px 10px 0px 10px;
  margin: 0px;

  @media screen and (max-width: 1350px) {
    font-size: 10px;
  }
`;
